exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.buttonBack {\n  background-color: white;\n  border: none;\n  position: absolute;\n}\n.DeclarationUBO {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  color: #1B1918;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-align: center;\n  max-width: 70%;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-028c1c98","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/LMSGiframe/components/HeaderBack.vue
// module id = 1515
// module chunks = 2